module.exports = require("@swa-ui/dotcom/src/DotcomMessages/DotcomMessages.module.scss");